import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  ["", "Popularity"],
  ["Netherlands", 33],
  ["Belgium", 26],
  ["Luxemburg", 22],
  ["Norway", 10], // Below limit.
];

export const options = {
 // title: "Popularity of Types of Pizza",
  sliceVisibilityThreshold: 0.2, // 20%
  legend: 'bottom',
  //backgroundColor: '#ECECEC',
  fontName: 'Roboto' , 
  fontSize: 13,
  colors: ['#2cb4d4','#1787b8','#255b98','#2f306d'],
  animation: {
    startup: true,
    easing: "linear",
    duration: 600,
  },
};

export default function PieChart() {
  return (
    <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"250px"}
    />
  );
}
